import React, { useEffect, useState } from "react";
import { LoadingDiv, SweetAlertShow } from "../master/Master";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { getStudentReviews } from "../../api/StudentReviews";
import { formatToDate } from "../master/FormatToDateTime";

export default function StudentsReviews() {
  const [loading, setLoading] = useState(false);
  const [reviews, setReviews] = useState([]);

  const getData = async () => {
    setLoading(true);
    try {
      const response = await getStudentReviews();
      if (response?.data?.status === true) {
        setReviews(response?.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12">
                        <h4 className="m-0">Student Reviews</h4>
                        <hr />
                      </div>
                      <div className="col-md-12">
                        <div className="table-responsive">
                          <table className="table table-hover">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Mobile No</th>
                                <th>Batch</th>
                                <th>Date</th>
                                <th>Subject</th>
                                <th>Complete Topic</th>
                                <th>Running Topic</th>
                                <th>Review</th>
                              </tr>
                            </thead>
                            <tbody>
                              {reviews?.map((item, i) => (
                                <tr key={i}>
                                  <td>{i + 1}</td>
                                  <td>
                                    {item?.student?.name} (
                                    {item?.student?.registration_no})
                                  </td>
                                  <td>{item?.student?.phone}</td>
                                  <td>{item?.course_fees?.batch?.title}</td>
                                  <td>{formatToDate(item?.date)}</td>
                                  <td>{item?.subject?.name}</td>
                                  <td>{item?.complete_topic}</td>
                                  <td>{item?.running_topic}</td>
                                  <td>{item?.issue}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
